import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const ImportantLinksSection = memo(({ theme, sectionId }) => {
  const ImportantLinksLayout = dynamic(() => import(/* webpackChunkName: 'ImportLinksSectionLayout' */ `../../../../../containers/home-page/views/sections/important-links/layouts/${theme.layout}`))

  return (
    <ImportantLinksLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

ImportantLinksSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default ImportantLinksSection
